export const Noise = () => <div className="noise-overlay" aria-hidden="true" />;
